export default __webpack_public_path__ + "static/Header-1-ded4b6f41980f03e23d77a13c14ad5de.jpg";